export default __webpack_public_path__ + "static/media/tour-guide-icon.f81420d1.svg";